var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "19.9 19.9 160.2 160.2",
    viewBox: "19.9 19.9 160.2 160.2",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "img",
    "aria-label": "Page d\\u2019accueil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kr8tvwgd svg [data-color=\"1\"] {fill: #000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M144.2 100c0 24.411-19.789 44.2-44.2 44.2S55.8 124.411 55.8 100 75.589 55.8 100 55.8s44.2 19.789 44.2 44.2z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 19.9c-44.2 0-80.1 35.9-80.1 80.1s35.9 80.1 80.1 80.1 80.1-35.9 80.1-80.1-35.9-80.1-80.1-80.1zm0 146.4c-36.6 0-66.3-29.7-66.3-66.3S63.4 33.7 100 33.7s66.3 29.7 66.3 66.3-29.7 66.3-66.3 66.3z",
    fill: "#000000",
    "data-color": 1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.a9d552a23bb3d38d5314828fae1fd7c8.svg";
export { ForwardRef as ReactComponent };